import { loc } from "../../../core/utils"
import React from "react"
import { Row } from "react-bootstrap"

const AdyenCBForm = ({ tunnelData }) => {
  return (
    <Row>
      <p>
        {loc`adyen_first_payment_intro`} € {tunnelData?.data?.order?.rent?.firstCustomerPayment}.
      </p>
      <br />

      <p>{loc`adyen_first_payment_review`}</p>
      <br />

      <p>{loc`adyen_first_payment_provider`}</p>
    </Row>
  )
}

export default AdyenCBForm
